import vi from 'date-format-parse/es/locale/vi.js'

const lang = {
  formatLocale: vi,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: false
}

export default lang
